const SPOKE_COUNT = 12;
// Matches mtd-itsa-package's LloydsSpinner cycle length and fade curve: each
// spoke sits dim (0.15) for the first 39% of the cycle, snaps to full
// opacity at 40%, then decays back to dim over the remaining 60%.
const CYCLE_SECONDS = 1.2;
const OPACITY_KEY_TIMES = "0;0.39;0.4;1";
const OPACITY_VALUES = "0.15;0.15;1;0.15";

interface Props {
  size?: number;
  color?: string;
}

/**
 * The 12-spoke fading wheel from the LBG "Payment sending" mobile design.
 *
 * MUI's `CircularProgress` only draws a sweeping arc, so the classic spoke
 * wheel is hand-rolled here (as an SVG since this component predates the
 * `LloydsSpinner` Box-based version in mtd-itsa-package). Each spoke fades on
 * its own offset of the same cycle, which reads as rotation without
 * animating a transform.
 */
// Black, matching the Lloyds spinner used elsewhere in the Bankifi Lloyds
// variant (mtd-itsa-package's LloydsSpinner) — a light grey read as barely
// visible against the page's own grey background.
const SpokeSpinner = ({ size = 40, color = "#000000" }: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    role="progressbar"
    aria-label="Loading"
    id="spokeSpinner">
    {Array.from({ length: SPOKE_COUNT }).map((_, index) => (
      <rect
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        x={18.6}
        y={3}
        width={2.8}
        height={9}
        rx={1.4}
        fill={color}
        transform={`rotate(${index * (360 / SPOKE_COUNT)} 20 20)`}>
        <animate
          attributeName="opacity"
          keyTimes={OPACITY_KEY_TIMES}
          values={OPACITY_VALUES}
          dur={`${CYCLE_SECONDS}s`}
          begin={`${(index * CYCLE_SECONDS) / SPOKE_COUNT}s`}
          repeatCount="indefinite"
        />
      </rect>
    ))}
  </svg>
);

export default SpokeSpinner;
